export default __webpack_public_path__ + "f3240cc629b27568eb804890b8958a1d.svg";